// Decision 84 #1 round 2 (F3; owner, 29 Oct 2026: "Make sure the upload-path fix covers this exact case: app closed or
// phone locked part-way through a batch"; Decision 85 #2: never leave a missing file out silently). A file picked but
// never kept on the phone (the page was ended, or the phone locked, part-way through saving a batch) is named on
// whatever screen the app opens on, not only in the Inbox: an iPhone home-screen app reopens on Today. One notice, not
// a toast: it stays until OK, and a file picked again or removed leaves it. It reads names only, never a file's bytes.
import { useLiveQuery } from "dexie-react-hooks";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { Button } from "../ui/primitives";
import { acknowledgeNeverKept, neverKeptToTell } from "./picks";
import type { Pick } from "./db";

export function NotKeptNotice() {
  const picks = useLiveQuery(neverKeptToTell, [], [] as Pick[]);
  if (!picks.length) return null;
  const one = picks.length === 1;
  return (
    <div role="alert" data-testid="not-kept-notice"
      className="sticky top-0 z-30 border-b border-danger/25 bg-surface px-4 py-3 text-[15px] text-ink shadow-sm">
      <div className="mx-auto flex max-w-5xl flex-wrap items-start gap-3">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-[rgb(var(--c-danger-text))]" aria-hidden />
        <div className="min-w-0 flex-1">
          <p className="font-medium">
            {one ? "A file you picked was not kept on this phone and was not sent:" : `${picks.length} files you picked were not kept on this phone and were not sent:`}
          </p>
          <ul className="mt-1 list-disc pl-5">
            {picks.map((p) => <li key={p.id} className="break-words">{p.name}</li>)}
          </ul>
          <p className="mt-1">
            Pick {one ? "it" : "them"} again in the <Link to="/inbox" className="font-medium text-primary underline">Inbox</Link>.
          </p>
        </div>
        <Button size="md" variant="secondary" onClick={() => void acknowledgeNeverKept(picks.map((p) => p.id))}>OK</Button>
      </div>
    </div>
  );
}
